export default __webpack_public_path__ + "src/assets/swap.af58de3b22e6f16130a09cdb30bb1ccb.svg";